import React from 'react';
import styled from 'styled-components';
import {
  statusFontColorMap,
  statusTextMap,
} from 'common/components/status/statusConfig';

const Tag = styled.span<any>`
  width: 69px;
  height: 22px;
  line-height: 22px;
  font-size: 12px;
  text-align: center;
  border-radius: 11px;
  display: inline-block;
  background: #f6f6f6;
  font-weight: 400;
  color: ${props => props.color};
`;

export default (props: { publishStatus: string }) => {
  const { publishStatus } = props;
  return (
    <Tag color={statusFontColorMap[publishStatus]}>
      <li>{`${statusTextMap[publishStatus]}`}</li>
    </Tag>
  );
};
